import { DROPDOWN_BUTTON_CLASS_NAME } from "./constants";

const buildDropdownButton = (selectElement: HTMLSelectElement) => {
  const dropdownButton = document.createElement("button");
  dropdownButton.type = "button";
  dropdownButton.className = DROPDOWN_BUTTON_CLASS_NAME;
  dropdownButton.setAttribute("aria-haspopup", "listbox");
  dropdownButton.setAttribute("aria-expanded", "false");
  dropdownButton.disabled = selectElement.disabled;

  const labelElement = document.createElement("span");
  labelElement.dataset.singleSelectLabel = "true";

  const iconElement = document.createElement("span");
  iconElement.className = "ml-3 shrink-0 text-primary-900";
  iconElement.setAttribute("aria-hidden", "true");
  iconElement.innerHTML = "&#9662;";

  dropdownButton.append(labelElement, iconElement);

  return dropdownButton;
};

export default buildDropdownButton;
